export default "__VITE_ASSET__BbplLdfd__"